import { TableResponse } from './table';
import { TrialState } from './trial';

export interface ProgressMetadata {
  checkpoint_id: string | null;
  trace_id: string;
  progressEstimate: number;
  waitingSentences: string[];
}

export interface Message {
    id: string;
    trace_id?: string;
    checkpoint_id?: string;
    content: string;
    timestamp: Date;
    sender: 'user' | 'ai';
    status: MessageStatus;
    isMarkdown?: boolean;
    tableData?: TableResponse;
    generated_html?: string;
    progress?: ProgressMetadata;
}

export interface TokenInit {
    access_token: string;
    user_data: any;
    organization_data: any;
    browser_language: string;
    frontend_base_url: string;
}

export enum MessageStatus {
    Sending = 'sending',
    Sent = 'sent', 
    Error = 'error',
    Streaming = 'streaming'
}
  
export interface ChatProps {
    messages: Message[];
    onSendMessage: (message: string) => Promise<void>;
    onRetry: (checkpointId: string, messageContent: string) => Promise<void>;
    isLoading?: boolean;
    error?: string;
    isTyping?: boolean;
    isCollapsed?: boolean;
    onToggleCollapse?: (isOpenning?: boolean, mode?: 'chat' | 'sidepanel' | 'fullscreen') => void;
    isStreaming?: boolean;
    isAuthenticating?: boolean;
    suggestions?: string[];
    initializationData?: TokenInit;
    progressData?: ProgressMetadata;
    // Trial-related props
    trialState?: TrialState;
    // Trial status banner props
    isTrial?: boolean;
    trialDaysRemaining?: number | null;
    currentOrganizationId?: string;
}

export interface Theme {
    primaryColor: string;
    borderWidth: string;
}

export interface ChatResponse {
  message: string;
  table?: TableResponse;  // Optional table data in response
  session_id: string;
  generated_html?: string;
}

export interface ChatHistoryResponse {
  session_id: string;
  messages: Array<{
    role: string;
    content: string;
    timestamp: string;
  }>;
  created_at: string;
}

export interface ExportSummaryResponse {
  summary: string;
  action_items: string[];
  insights: string[];
}